import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { StockItemLogEntity } from './stock-item-category-log.entity';
import { StockItemCategoryController } from './stock-item-category.controller';
import { StockItemEntity } from './stock-item-category.entity';
import { StockItemCategoryService } from './stock-item-category.service';



@Module({
  imports: [
    TypeOrmModule.forFeature([StockItemEntity,StockItemLogEntity]),
  ],
  controllers: [StockItemCategoryController],
  providers: [StockItemCategoryService, ApplicationExceptionHandler,LogsService]
})
export class StockItemCategoryModule { }
